import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

import I18n from '@module/i18n';
import { consentTracker } from '@module/consent-manager';

import Button from '@component/form/element/button';

import {
  Intro,
  AcceptButton,
  SaveButton,
  RejectButton,
  PurposeList,
  VendorList,
} from '@component/consent-manager';
import { useConsentLanguage } from '../consent-manager/useConsentLanguageHook';

export const ConsentWall = ({ closePanel, language }) => {
  const [showPreferences, setShowPreferences] = useState(false);

  const consentLanguage = useConsentLanguage(language);

  useEffect(() => consentTracker.showModal(), []);

  const handleOnClick = () => closePanel();

  const handlePrivacyPrefClick = () => {
    setShowPreferences(true);
    consentTracker.clickPrivacyPreferences();
  };

  return (
    <div
      className={classNames('welcome__content welcome__cookie-notice', {
        'welcome__cookie-notice-full-height': showPreferences,
      })}
    >
      <div className="welcome__cookie-notice-title">
        {I18n.t('transfer.consent-manager.headline')}
      </div>
      {showPreferences ? (
        <React.Fragment>
          <Intro>
            <RejectButton onClick={handleOnClick} context="intro_preference" />
            <SaveButton onClick={handleOnClick} context="intro_preference" />
            <AcceptButton onClick={handleOnClick} context="intro_preference" />
          </Intro>

          <div className="welcome__consent-preferences">
            <div className="welcome__purpose-list">
              <div className="welcome__cookie-notice-title">
                {I18n.t('transfer.consent-manager.preferences-headline')}
              </div>
              <div
                className="welcome__cookie-notice-text"
                dangerouslySetInnerHTML={{
                  __html: I18n.t('transfer.consent-manager.preferences-text'),
                }}
              />
              <div
                className="welcome__cookie-notice-text"
                dangerouslySetInnerHTML={{
                  __html: I18n.t(
                    'transfer.consent-manager.preferences-text-allow-cookies'
                  ),
                }}
              />
              <PurposeList consentLanguage={consentLanguage} />
            </div>

            <div className="welcome__buttons ">
              <Button
                text={I18n.t('transfer.consent-manager.button-reject')}
                className="welcome__button welcome__button--decline welcome__button--hidden"
              />
              <SaveButton
                onClick={handleOnClick}
                context="purpose_preference"
              />
              <AcceptButton
                onClick={handleOnClick}
                context="purpose_preference"
              />
            </div>

            <div className="welcome__cookie-notice-title welcome__consent-title">
              {I18n.t('transfer.consent-manager.partners-headline')}
            </div>
            <div
              className="welcome__cookie-notice-text"
              dangerouslySetInnerHTML={{
                __html: I18n.t('transfer.consent-manager.partners-text'),
              }}
            />

            <VendorList consentLanguage={consentLanguage} />

            <div className="welcome__buttons welcome__buttons-vendor-list">
              <Button
                text={I18n.t('transfer.consent-manager.button-reject')}
                className="welcome__button welcome__button--decline welcome__button--hidden"
              />
              <SaveButton onClick={handleOnClick} context="vendor_preference" />
              <AcceptButton
                onClick={handleOnClick}
                context="vendor_preference"
              />
            </div>
          </div>
        </React.Fragment>
      ) : (
        <Intro>
          <RejectButton onClick={handleOnClick} context="intro_splash" />
          <Button
            text={I18n.t('transfer.consent-manager.manage-cookies')}
            className="welcome__button welcome__button--preferences"
            onClick={handlePrivacyPrefClick}
          />
          <AcceptButton onClick={handleOnClick} context="intro_splash" />
        </Intro>
      )}
    </div>
  );
};

ConsentWall.propTypes = {
  closePanel: PropTypes.func.isRequired,
  language: PropTypes.string,
};

const mapStateToProps = ({ session: { language } }) => ({ language });
export const ConnectedConsentWall = connect(mapStateToProps)(ConsentWall);
